import { render, staticRenderFns } from "./BrowseDaichoView.vue?vue&type=template&id=012488a2&scoped=true&"
import script from "./BrowseDaichoView.vue?vue&type=script&lang=js&"
export * from "./BrowseDaichoView.vue?vue&type=script&lang=js&"
import style0 from "./BrowseDaichoView.vue?vue&type=style&index=0&id=012488a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012488a2",
  null
  
)

export default component.exports